import React, { createContext, useContext } from 'react';

export const SignUpContext = createContext({
  patientForm: {},
  setPatientForm: {},
  setFooterButton: () => { },
  setCurrent: 0,
  setCurrentProcess: 0,
  registrationToken: '', 
  setRegistrationToken: '',
});

export const useFooterButton = () => useContext(SignUpContext);
